/* ============================================================
   Daps — global theme interactions
   nav drawer · faq accordion · pdp gallery · flavors showcase ·
   email popup · smooth in-page scroll
   (The buy module lives in daps-buy.js; the marquee is CSS-only.)
   ============================================================ */
(function () {
  "use strict";
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var get = function (k, d) { try { return localStorage.getItem(k) || d; } catch (e) { return d; } };
  var set = function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} };

  /* ---------- mobile nav drawer ---------- */
  function initDrawer() {
    /* delegated so it keeps working after Theme Editor section reloads */
    function close() { var d = $("[data-nav-drawer]"); if (d) { d.classList.remove("is-open"); document.body.style.overflow = ""; } }
    document.addEventListener("click", function (e) {
      if (e.target.closest("[data-menu-open]")) {
        var d = $("[data-nav-drawer]");
        if (d) { d.classList.add("is-open"); document.body.style.overflow = "hidden"; var c = $(".navdrawer__close", d); if (c) c.focus(); }
      } else if (e.target.closest("[data-menu-close]")) {
        close();
      }
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") { var d = $("[data-nav-drawer]"); if (d && d.classList.contains("is-open")) close(); }
    });
  }

  /* ---------- FAQ accordion ---------- */
  function initFaq(scope) {
    $$(".faq__item", scope).forEach(function (item) {
      var q = $(".faq__q", item), a = $(".faq__a", item);
      if (!q || !a || q.dataset._wired) return;
      q.dataset._wired = "1";
      q.addEventListener("click", function () {
        var open = item.classList.toggle("open");
        a.style.maxHeight = open ? a.scrollHeight + "px" : "0";
        q.setAttribute("aria-expanded", open);
      });
    });
  }

  /* ---------- PDP gallery ---------- */
  function initGallery() {
    var main = $("[data-gal-main]");
    if (!main) return;
    function setMain(src) {
      if (!src) return;
      main.style.opacity = "0";
      setTimeout(function () { main.src = src; main.style.opacity = "1"; }, 120);
      $$(".gal__thumb").forEach(function (t) { t.setAttribute("aria-pressed", t.getAttribute("data-src") === src); });
    }
    $$(".gal__thumb").forEach(function (t) {
      t.addEventListener("click", function () { setMain(t.getAttribute("data-src")); });
    });
    /* mirror the flavor's variant image (fired by daps-buy.js) */
    document.addEventListener("daps:flavorchange", function (e) {
      var img = e.detail && e.detail.image;
      if (!img) return;
      var flavThumb = $(".gal__thumb[data-flavor-thumb]");
      if (flavThumb) {
        flavThumb.setAttribute("data-src", img);
        var im = $("img", flavThumb); if (im) im.src = img;
        if (flavThumb.getAttribute("aria-pressed") === "true") setMain(img);
      } else {
        setMain(img);
      }
    });
  }

  /* ---------- flavors showcase (home) ---------- */
  function initFlavorShowcase() {
    $$("[data-flavor-showcase]").forEach(function (sc) {
      var img = $("[data-fl-img]", sc), glow = $("[data-fl-glow]", sc),
          desc = $("[data-fl-desc]", sc), tags = $("[data-fl-tags]", sc),
          cta = $("[data-fl-cta]", sc);
      /* preload every flavor image up front so switching never flashes a blank/late frame */
      $$("[data-fl-btn]", sc).forEach(function (b) {
        var pre = b.getAttribute("data-image");
        if (pre) { var im = new Image(); im.src = pre; }
      });
      $$("[data-fl-btn]", sc).forEach(function (b) {
        b.addEventListener("click", function () {
          $$("[data-fl-btn]", sc).forEach(function (x) { x.setAttribute("aria-pressed", "false"); });
          b.setAttribute("aria-pressed", "true");
          var src = b.getAttribute("data-image");
          if (img && src) { img.style.opacity = "0"; setTimeout(function () { img.src = src; img.style.opacity = "1"; }, 90); }
          if (glow && b.getAttribute("data-glow")) glow.style.background = b.getAttribute("data-glow");
          if (desc) desc.innerHTML = b.getAttribute("data-desc") || "";
          if (tags) {
            var t = (b.getAttribute("data-tags") || "").split(",").map(function (s) { return s.trim(); }).filter(Boolean);
            tags.innerHTML = t.map(function (x) { return "<span>" + x + "</span>"; }).join("");
          }
          if (cta) { var shopUrl = b.getAttribute("data-shop-url"); if (shopUrl) cta.setAttribute("href", shopUrl); }
        });
      });
      var first = $("[data-fl-btn]", sc);
      if (first) first.click();
    });
  }

  /* ---------- email popup ---------- */
  function initPopup() {
    var pop = $("[data-popup]");
    if (!pop) return;
    var key = "daps_popup_dismissed";
    var delay = parseInt(pop.getAttribute("data-delay"), 10) || 14;
    function open() { pop.classList.add("show"); }
    function close() { pop.classList.remove("show"); set(key, "1"); }
    $$("[data-pop-close]", pop).forEach(function (b) { b.addEventListener("click", close); });
    $$(".pop__opts button", pop).forEach(function (b) {
      b.addEventListener("click", function () {
        $$(".pop__opts button", pop).forEach(function (x) { x.setAttribute("aria-pressed", "false"); });
        b.setAttribute("aria-pressed", "true");
        var claim = $("[data-pop-claim]", pop); if (claim) claim.disabled = false;
        var tags = $("[data-pop-tags]", pop); if (tags) tags.value = "newsletter, popup, " + b.textContent.trim();
      });
    });
    if (get(key, "") === "1") return;
    var shown = false;
    function fire() { if (shown) return; shown = true; open(); window.removeEventListener("scroll", onScroll); }
    function onScroll() {
      var sc = window.pageYOffset || document.documentElement.scrollTop || 0;
      var h = document.documentElement.scrollHeight - window.innerHeight;
      if (h > 0 && sc / h > 0.35) fire();
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    setTimeout(fire, delay * 1000);
  }

  /* ---------- smooth in-page scroll (offset for sticky nav) ---------- */
  function initScroll() {
    document.addEventListener("click", function (e) {
      var a = e.target.closest('a[href*="#"], [data-scroll]');
      if (!a) return;
      var raw = a.getAttribute("data-scroll") || a.getAttribute("href") || "";
      var hi = raw.indexOf("#");
      if (hi < 0) return;
      var id = raw.slice(hi + 1);
      if (!id) return;
      /* only intercept links that resolve to THIS page (pure #hash, or a root/anchor link on the same path) */
      var samePage = raw.charAt(0) === "#" || (a.tagName === "A" && a.pathname === window.location.pathname);
      if (!samePage) return;
      var el = document.getElementById(id);
      if (!el) return;
      e.preventDefault();
      var nav = $(".nav");
      var off = (nav ? nav.offsetHeight : 0) + 12;
      var y = el.getBoundingClientRect().top + window.pageYOffset - off;
      window.scrollTo({ top: y < 0 ? 0 : y, behavior: "smooth" });
      if (history.replaceState) { try { history.replaceState(null, "", "#" + id); } catch (err) {} }
      var drawer = $("[data-nav-drawer]");
      if (drawer) { drawer.classList.remove("is-open"); document.body.style.overflow = ""; }
    });
  }

  /* ---------- video lightbox: tap a clip to open it enlarged in a centered box ---------- */
  var _lb = null;
  function ensureLightbox() {
    if (_lb) return _lb;
    var ov = document.createElement("div");
    ov.className = "vlb";
    ov.setAttribute("role", "dialog");
    ov.setAttribute("aria-modal", "true");
    ov.innerHTML =
      '<div class="vlb__box">' +
      '<button class="vlb__close" type="button" aria-label="close video">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg>' +
      '</button><video playsinline controls preload="auto"></video></div>';
    document.body.appendChild(ov);
    var vid = $("video", ov);
    function close() {
      ov.classList.remove("is-open");
      document.body.style.overflow = "";
      try { vid.pause(); } catch (e) {}
      vid.removeAttribute("src");
      vid.innerHTML = "";
      try { vid.load(); } catch (e) {}
    }
    $(".vlb__close", ov).addEventListener("click", close);
    ov.addEventListener("click", function (e) { if (e.target === ov) close(); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && ov.classList.contains("is-open")) close(); });
    _lb = { ov: ov, vid: vid, close: close };
    return _lb;
  }
  function openLightbox(srcVideo) {
    var lb = ensureLightbox();
    var vid = lb.vid;
    vid.innerHTML = "";
    vid.removeAttribute("src");
    var poster = srcVideo.getAttribute("poster");
    if (poster) vid.setAttribute("poster", poster); else vid.removeAttribute("poster");
    var srcs = $$("source", srcVideo);
    if (srcs.length) {
      srcs.forEach(function (s) { var n = document.createElement("source"); n.src = s.src; if (s.type) n.type = s.type; vid.appendChild(n); });
    } else if (srcVideo.currentSrc || srcVideo.src) {
      vid.src = srcVideo.currentSrc || srcVideo.src;
    }
    vid.muted = false;
    try { vid.load(); } catch (e) {}
    lb.ov.classList.add("is-open");
    document.body.style.overflow = "hidden";
    var p = vid.play();
    if (p && p.catch) p.catch(function () {});
  }
  function initVideoClips(scope) {
    ensureLightbox();
    $$(".vclip", scope || document).forEach(function (clip) {
      if (clip.dataset._vclip) return;
      var video = $("video", clip);
      if (!video) return; /* image-only card — nothing to open */
      clip.dataset._vclip = "1";
      clip.style.cursor = "pointer";
      clip.setAttribute("role", "button");
      clip.setAttribute("tabindex", "0");
      clip.addEventListener("click", function () { openLightbox(video); });
      clip.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") { e.preventDefault(); openLightbox(video); }
      });
    });
  }

  /* ---------- background videos: play only while on-screen (saves data/battery) ---------- */
  function initAutoplayVideos(scope) {
    var vids = $$("video[data-bgvideo]", scope || document);
    if (!vids.length) return;
    function playV(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    if (!("IntersectionObserver" in window)) { vids.forEach(playV); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) playV(en.target); else en.target.pause(); });
    }, { threshold: 0.01, rootMargin: "500px 0px 500px 0px" });
    vids.forEach(function (v) { if (v.dataset._bg) return; v.dataset._bg = "1"; io.observe(v); });
  }

  /* ---------- review carousel: drag-to-scroll (desktop mouse) ---------- */
  function initReviewCarousels(scope) {
    $$(".reviews__track", scope || document).forEach(function (track) {
      if (track.dataset._carousel) return;
      track.dataset._carousel = "1";
      var down = false, startX = 0, startLeft = 0, moved = 0;
      track.addEventListener("pointerdown", function (e) {
        if (e.pointerType === "touch") return; /* native touch scroll */
        down = true; moved = 0; startX = e.clientX; startLeft = track.scrollLeft;
        try { track.setPointerCapture(e.pointerId); } catch (err) {}
        track.classList.add("is-grabbing");
      });
      track.addEventListener("pointermove", function (e) {
        if (!down) return;
        var dx = e.clientX - startX; moved = Math.abs(dx);
        track.scrollLeft = startLeft - dx;
      });
      function end(e) { if (!down) return; down = false; track.classList.remove("is-grabbing"); try { track.releasePointerCapture(e.pointerId); } catch (err) {} }
      track.addEventListener("pointerup", end);
      track.addEventListener("pointercancel", end);
      /* swallow the click that ends a drag so cards/links don't fire */
      track.addEventListener("click", function (e) { if (moved > 6) { e.preventDefault(); e.stopPropagation(); } }, true);
      /* prev/next arrows removed — the carousel auto-rotates + drags + native-scrolls, so they're redundant */
    });
  }

  /* ---------- auto-rotating carousels: reviews, UGC photos, video rails ---------- */
  /* Continuous slow marquee. Content is cloned once (or more) so it loops with no jump.
     Pauses on hover, while dragging/swiping/wheeling, and while a clip is playing.
     Honors prefers-reduced-motion. Shared by home reviews + UGC and the PDP proof block. */
  function initAutoScroll(scope) {
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    var sels = [".reviews__track", ".reviews__ugc", ".social__rail"];
    sels.forEach(function (sel) {
      $$(sel, scope || document).forEach(function (track) {
        if (track.dataset._marquee) return;
        var originals = Array.prototype.slice.call(track.children);
        if (originals.length < 2) return;
        track.dataset._marquee = "1";
        track.style.scrollSnapType = "none"; /* don't let scroll-snap fight the drift */

        function appendSet() {
          originals.forEach(function (n) {
            var c = n.cloneNode(true);
            c.setAttribute("aria-hidden", "true");
            c.setAttribute("tabindex", "-1");
            c.dataset.clone = "1";
            track.appendChild(c);
          });
        }
        /* enough copies that the strip is at least ~2 viewports wide → always seamless */
        var guard = 0;
        appendSet();
        while (track.scrollWidth < track.clientWidth * 2 && guard < 12) { appendSet(); guard++; }

        var wrapDist = 0;
        function remeasure() {
          var fc = track.children[originals.length];
          if (fc) wrapDist = fc.offsetLeft - track.children[0].offsetLeft;
        }
        remeasure();
        window.addEventListener("resize", remeasure);
        setTimeout(remeasure, 600); /* re-measure after late image/video layout */

        var speed = parseFloat(track.getAttribute("data-autoscroll")) || 0.55; /* px/frame ≈ 33px/s (between the first 0.4 and 0.7) */
        var hover = false, interacting = false, vplaying = 0, idle = null, pos = track.scrollLeft;
        function nudge() { interacting = true; clearTimeout(idle); idle = setTimeout(function () { interacting = false; }, 2600); }
        track.addEventListener("mouseenter", function () { hover = true; });
        track.addEventListener("mouseleave", function () { hover = false; });
        track.addEventListener("pointerdown", nudge);
        track.addEventListener("touchstart", nudge, { passive: true });
        track.addEventListener("wheel", nudge, { passive: true });
        /* pause while a clip is actually playing (play/pause/ended don't bubble → capture) */
        track.addEventListener("play", function (e) { if (e.target && e.target.tagName === "VIDEO") vplaying++; }, true);
        function vend(e) { if (e.target && e.target.tagName === "VIDEO" && vplaying > 0) vplaying--; }
        track.addEventListener("pause", vend, true);
        track.addEventListener("ended", vend, true);

        function tick() {
          if (hover || interacting || vplaying > 0) {
            pos = track.scrollLeft; /* stay synced to any manual scroll */
          } else if (wrapDist > 0) {
            pos += speed;
            while (pos >= wrapDist) pos -= wrapDist;
            track.scrollLeft = pos;
          }
          requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
      });
    });
  }

  function boot() {
    initDrawer(); initFaq(document); initGallery(); initFlavorShowcase(); initPopup(); initScroll();
    initReviewCarousels(document); initAutoScroll(document); initVideoClips(document); initAutoplayVideos(document);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("shopify:section:load", function (e) { initFaq(e.target); initGallery(); initFlavorShowcase(); initReviewCarousels(e.target); initAutoScroll(e.target); initVideoClips(e.target); initAutoplayVideos(e.target); });
})();
